"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    background: {
        type: String,
        default: undefined
    },
    border: {
        type: Object,
        default: undefined
    },
    color: {
        type: String,
        default: undefined
    },
    encoding: {
        type: String,
        default: undefined
    },
    errorCorrection: {
        type: String,
        default: undefined
    },
    padding: {
        type: Number,
        default: undefined
    },
    renderAs: {
        type: String,
        default: undefined
    },
    size: {
        type: [Number, String],
        default: undefined
    },
    value: {
        type: [Number, String],
        default: undefined

        // Events
    } };